<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-label slot="start">
      <ion-title> Please assign the tip to a staff member</ion-title>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row
      *ngFor="let stylistTip of stylistTips; let stylistTipIndex = index"
      lines="none"
    >
      <ion-col size="11">
        <smr-stylist-picker
          (stylistSelect)="onStylistSelectChange($event, stylistTipIndex)"
          cssClass="smr-stylist-picker-for-tip"
          [stylistID]="stylist.id" 
        >
        </smr-stylist-picker>
      </ion-col>
      <ion-col size="1" *ngIf="stylistTipIndex != 0">
        <ion-button fill="clear" (click)="removeMember(stylistTipIndex)">
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-col>

      <ion-col size="12">
        <ion-input
          [maskito]="currencyMask"
          [maskitoElement]="maskPredicate"
          [(ngModel)]="stylistTip.amount"
          (ionChange)="editAmount()"
        >
        </ion-input>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-button expand="block" fill="outline" class="ion-margin" (click)="addMember()">
    Split tip with another staff member
  </ion-button>

  <div class="ion-text-center">
    <h4>Tip remaining to assign: {{ tipRemaining | salonMonsterCurrency }}</h4>
  </div>
</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-button
    expand="full"
    color="primary"
    class="ion-no-margin"
    [disabled]="!completed"
    (click)="save()"
  >
    Save
  </ion-button>
</ion-footer>
